<template>
  <div id="app">
		<!-- <indexHeader ref="indexHeader"></indexHeader> -->
    <router-view/>
		<!-- <indexFooter></indexFooter> -->
  </div>
</template>

<script>
import indexHeader from "@/components/index/index_header";
import indexFooter from "@/components/index/index_footer";
export default {
  name: 'App',
	components: {
	  indexHeader,
	  indexFooter
	}
}
</script>
<style>
	.el-message{
		top: 30% !important;
	}
	.search_tabel .cell{
		text-align: center;
	}
	/* 首页信用报告查询 */
	.mk_title{
		font-size: 18px;
		margin-top: -15px;
		margin-bottom: 15px;
		font-weight: 700;
	}
	.mk_title i{
		color: #67c23a;
	}
	.mk_center{
		font-size: 16px;
		line-height: 26px;
	}
</style>




// WEBPACK FOOTER //
// src/App.vue